import { createThemeCompiler } from '../../../utils';

export const toolbarThemeCompiler = createThemeCompiler(({ palette, boxShadow }) => ({
    toolbar: {
        colors: {
            backgroundColor: palette.white,
            menuIconColor: palette.themePrimary,
            menuTitleColor: palette.neutralPrimary,
            separatorBackgroundColor: palette.neutralTertiary
        },
        composites: {
            boxShadow: boxShadow.normal,
            boxShadowOnItemHover: boxShadow.none
        }
    }
}));
